import React from 'react'
import GithubCalendar from "react-github-calendar"
import "./Stats.css"

const Stats = () => {
    return (
        <div className='stats'>
            <h1 className='heading_github'>Github's Stats</h1>
            <div className='github'>
                <GithubCalendar username='Gulshan7777' year={new Date().getFullYear()} blockSize={15} blockMargin={5} fontSize={16} color="#f9004d" />

            </div>
            <div className='secondGithub'>
                <img src="https://github-readme-stats.vercel.app/api?username=Gulshan7777&show_icons=true&hide_border=true&theme=radical" />
                <img src="https://github-readme-streak-stats.herokuapp.com/?user=Gulshan7777&hide_border=true&theme=radical" />
            </div>
        </div>
    )
}

export default Stats